
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.62 2H6.38C5.065 2 4 2.753 4 3.907V15.91C4 17.064 5.066 18 6.38 18h7.24c1.314 0 2.38-.936 2.38-2.09V4.09C16 2.937 14.934 2 13.62 2zM6 14h8V4H6v10zm3 2a1 1 0 102 0 1 1 0 00-2 0z","fill":"#B4BCCF"}})])
          )
        }
      }
    